import React from 'react';
import './CheckoutTitleWidget.css';

export type CheckoutTitleWidgetProps = {
  title?: string;
  subtitle?: string;
  className?: string;
};

/**
 * CheckoutTitleWidget
 * Simple pill-like banner for the checkout header.
 * Default style matches the provided mock: light gray background, rounded corners, emoji icon, bold title and small subtitle.
 */
const CheckoutTitleWidget: React.FC<CheckoutTitleWidgetProps> = ({
  title = '',
  subtitle = '',
  className = '',
}) => {
  return (
    <div className={`checkout-title-widget ${className}`}>
      <div className="ctw-texts">
        <div className="ctw-title">🌟&nbsp;{title}</div>
        {subtitle && <div className="ctw-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default CheckoutTitleWidget;
